<app-stages [stages]="stages" currentStage="Informacje podstawowe"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)="submitAndGoNext()">
    <div class="row">
      <div class="col-md-4">
        <div class='form-group' *ngIf='"leasePurpose" as controlName'>
          <label [for]='controlName'>
            Cel dzierżawy *
          </label>
          <select
            (change)="form.leasePurposeChange(form.getElement($event).value)"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            @for (item of form.leasePurposeList; track $index) {
              <option [value]='item'>{{ item }}</option>
            }
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      @if (form.description) {
        <div class='col-12'>
          <div class='form-group' *ngIf='"description" as controlName'>
            <label [for]='controlName'>
              Inne cele *
            </label>
            <textarea
              rows='4'
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu inne cele'>
            </textarea>
            <app-validation-errors [showTextLength]='true' [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
    <fieldset>
      <legend>
        Okres
      </legend>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"startDate" as controlName'>
            <label [for]='controlName'>
              Data od *
            </label>
            <app-date-picker
              mode="day"
              [id]='controlName'
              [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"endDate" as controlName'>
            <label [for]='controlName'>
              Data do *
            </label>
            <app-date-picker
              mode="day"
              [id]='controlName'
              [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors fieldLabel='Data od' secondFieldLabel='dacie do' [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset>
      <legend>
        Dane działki
      </legend>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"city" as controlName'>
            <label [for]='controlName'>
              Miejscowość *
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu miejscowość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"street" as controlName'>
            <label [for]='controlName'>
              Ulica *
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu nazwę ulicy'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"registrationNumber" as controlName'>
            <label [for]='controlName'>
              Numer ewidencyjny *
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu numer'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-3'>
          <div class='form-group' *ngIf='"area" as controlName'>
            <label [for]='controlName'>
              Powierzchnia m<sup>2</sup> *
            </label>
            <input
              mask="separator.2"
              decimalMarker=","
              [dropSpecialCharacters]="false"
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu powierzchnie'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <div class='application-actions'>
      @if (!uiSettings()?.mobileEmbed) {
        <button
          type='button'
          class='btn btn-secondary'
          (click)='onCancel()'>
        <span>
          Wstecz
        </span>
        </button>
      }
      <button
        type='submit'
        class='btn btn-primary'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
